<template lang="html">

<!-- <slot name="header" :snack_bar="snack_bar"/> -->
  <StandardCard
    :image="member.image !== 'noimage'? member.image:'https://cdn.pixabay.com/photo/2014/05/02/23/46/new-york-city-336475_1280.jpg'"
    :name="member.first_name + ' ' + member.last_name"
    >
    <template #info>
      <v-list two-line>
        <v-list-item>
          <v-list-item-action>
            <v-icon color="blue">assignment_ind</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <slot name="role" :member="member" />
            <v-list-item-subtitle>
              {{$t('Company.Member.Role')}}
            <slot name="role-actions" :member="member" />
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-action>
            <v-tooltip
              :open-on-hover="false"
              bottom
            >
              <template #activator="{ on }">
                <v-icon
                  @click="on.click"
                  @blur="on.blur"
                  @click.native="copyToClipboard(member.phone_number)"
                  color="blue"
                >
                phone
                </v-icon>
              </template>
              <span>Copied!</span>
              </v-tooltip>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{member.phone_number || 'n/a'}}</v-list-item-title>
            <v-list-item-subtitle>{{$t('Company.Member.PhoneNumber')}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-action>
            <v-tooltip
              :open-on-hover="false"
              bottom
            >
              <template #activator="{ on }">
                <v-icon
                  @click="on.click"
                  @blur="on.blur"
                  @click.native="copyToClipboard(member.email)"
                  color="blue"
                >
                mail
                </v-icon>
              </template>
              <span>Copied!</span>
              </v-tooltip>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{member.email}}</v-list-item-title>
            <v-list-item-subtitle>{{$t('Company.Member.Email')}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <slot name="remove-member" :member="member" />
        <slot name="last-updated" :member="member" />
      </v-list>
    </template>
  </StandardCard>
</template>
<script>
import StandardCard from '@/components/StandardComponents/StandardCard.component.vue'
export default {
  components: { StandardCard },
  props: ['member'],
  methods: {
    copyToClipboard(textToCopy) {      
      navigator.clipboard.writeText(textToCopy);
    }
  }
}
</script>
